import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
            {title}
          </h2>
        </div>
        {desc && (
          <p className="mt-2 text-sm text-foreground-500">{desc}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 whitespace-nowrap cursor-pointer shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}